import { render } from "./ItemVePC.vue?vue&type=template&id=f92a503c"
import script from "./ItemVePC.vue?vue&type=script&lang=js"
export * from "./ItemVePC.vue?vue&type=script&lang=js"

import exportComponent from "E:\\SonPhat\\Project\\BanVe\\TraCuuVe_FE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__